export function initClarity() {
  const key = window.CONFIG?.REACT_APP_CLARITY_KEY;
  
  if (!key) {
    console.warn("Clarity key não definida em window.CONFIG");
    return;
  }

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", key);
}
